import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Validatable } from './validatable'
import { FormValidationService } from './form-validation-service'

export interface ValidatedRadioButtonModel {
    value: string,
    htmlLabel: string,
    helperText?: string,
    showHelperText?: boolean,
    disabled?: boolean
}

@Component({
    selector: 'ValidatedRadioButtonGroup',
    templateUrl: './html-templates/validated-radio-button-group.component.html'
})

export class ValidatedRadioButtonGroupComponent extends Validatable<string> {
    @Input() radioGroupName: string
    @Input() options: ValidatedRadioButtonModel[]
    @Input() selectedValue: string
    @Input() label: string
    @Input() labelClass: string
    @Input() isBlueText: boolean
    @Input() validationLabel: string
    @Output() onValueChange: EventEmitter<string> = new EventEmitter<string>()

    constructor(formValidationService: FormValidationService) {
        super(formValidationService)
    }

    setValue(option: any) {
            this.hideAllHelperText()
            option.showHelperText = true
            this.selectedValue = option.value
            this.onValueChange.emit(option.value)
            this.clearValidationErrors()
    }

    getLabel() {
        if (this.validationLabel) {
            return this.validationLabel
        } else {
            return this.label
        }
    }

    getValue() {
        return this.selectedValue
    }

    private hideAllHelperText() {
        for (let option of this.options) {
            option.showHelperText = false
        }
    }

    onBlur() {
        this.validate()
    }
}

